"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Requests = void 0;
const Paths_1 = require("./Paths");
const Utils_1 = require("./Utils");
class Requests {
    constructor(session) {
        this.session = session;
    }
    get url() { return `${this.session.baseUrl}/${this.resource}`; }
    getUrl() {
        return this.url;
    }
    request(options, path) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options);
            return (0, Utils_1.wrapFetch)(request, path);
        });
    }
    getAll() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request({ method: Paths_1.Methods.GET }, this.url);
        });
    }
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request({ method: Paths_1.Methods.GET }, `${this.url}/${id}`);
        });
    }
    post(body) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request({
                method: Paths_1.Methods.POST,
                body,
            }, this.url);
        });
    }
    put(id, body) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request({
                method: Paths_1.Methods.PUT,
                body,
            }, `${this.url}/${id}`);
        });
    }
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.request({ method: Paths_1.Methods.DELETE }, `${this.url}/${id}`);
        });
    }
    create(body) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.post(body);
        });
    }
    update(id, body) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.put(id, body);
        });
    }
    remove(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.delete(id);
        });
    }
}
exports.Requests = Requests;
//# sourceMappingURL=Requests.js.map